module.exports = __webpack_public_path__ + "assets/img/xuehuadongtu.750b10a9.gif";